'use client';

import Link from 'next/link';
import type { User } from '@supabase/supabase-js';
import { captureEvent, EVENTS } from '@/lib/posthog/events';

interface LandingHeroCtaProps {
  user: User | null;
  hasAccess: boolean;
  className: string;
  /** Which landing CTA this is — reported on cta_clicked. */
  location: 'hero' | 'final_cta';
}

// Unauth visitor          → "Get Started"      → /signup
// Authed, no trial/sub    → "Get Started"      → /pricing (start trial / pick a plan)
// Authed with access      → "Go to Odds Screen"→ /odds-screen, the resolver that picks the
//                            right live board server-side (their live sport, or the live one
//                            when theirs is off-season) — no client season-load flash.
export function LandingHeroCta({ user, hasAccess, className, location }: LandingHeroCtaProps) {
  const [href, label] =
    user && hasAccess
      ? ['/odds-screen', 'Go to Odds Screen']
      : [user ? '/pricing' : '/signup', 'Get Started'];
  return (
    <Link
      href={href}
      className={className}
      onClick={() => captureEvent(EVENTS.CTA_CLICKED, { location, label, destination: href })}
    >
      {label}
    </Link>
  );
}
